import React, { Component } from 'react'
import styled from 'styled-components'

import { colors, rhythm, media } from '../utils/style-utils'
import AppContainer from './AppContainer'
import { Subscribe } from 'unstated'

const ProductWrapper = styled.article`
  & + & {
    margin-top: ${rhythm(1)};
  }
`

const ProductInner = styled.div`
  background-color: ${colors.white};
  color: ${colors.black};
  padding: ${rhythm(1)};
  ${media.tablet`
    padding: ${rhythm(1)} ${rhythm(3)};
    display: flex;
  `};
`

const ProductHeader = styled.div`
  text-align: center;
  padding: ${rhythm(1)} 0;
  flex-shrink: 0;
  border-bottom: 1px solid #dfdfdf;

  ${media.tablet`
    padding-right: inherit;
    border: 0;
    border-right: 1px solid #dfdfdf;
    width: 200px;
  `} ${media.desktop`
    width: 300px;
  `};
`

const ProductImage = styled.div`
  img {
    display: block;
    width: 100%;
    margin: 0 auto;
    max-width: 150px;

    ${media.tablet`
      max-width: none;
    `};
  }
`
const ProductTitle = styled.h2`
  font-weight: bold;
  letter-spacing: 0.22em;
  line-height: 1.2;
  text-transform: uppercase;
  font-size: 1.2rem;
`
const ProductContent = styled.div`
  padding: ${rhythm(1)};
  flex-grow: 1;

  ${media.tablet`
    padding-left: ${rhythm(5)};
  `};
`
const ProductDescription = styled.div``

const ProductIntroTitle = styled.h3`
  font-weight: 300;
  letter-spacing: 0.14em;
  line-height: 1.2;
  text-transform: uppercase;
  font-size: 1.5rem;
  margin-bottom: ${rhythm(1)};

  ${media.tablet`
    font-size: 2.23rem;
    margin-bottom: ${rhythm(3)};  
  `};
`

const Button = styled.button`
  cursor: pointer;
  background-color: #d9bb62;
  color: ${colors.white};
  font-size: 13px;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: bold;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  padding: 1em 2em;
  transition: 300ms;

  &:hover {
    color: ${colors.black};
  }
`

class ProductDetail extends Component {
  componentDidMount() {
    this.animateIn()
  }

  componentDidUpdate() {
    this.animateIn()
  }

  animateIn() {
    TweenMax.fromTo(
      this.wrapper,
      1,
      { y: '100', opacity: 0 },
      { y: 0, opacity: 1, ease: Strong.easeInOut }
    )
  }

  render() {
    const { data, category, dynamic_title, order_label } = this.props
    const { title, productImage } = data.frontmatter
    const { html } = data
    const productImageSrc = productImage.childImageSharp.original.src

    const formatted_title = dynamic_title
      .split('%STAIN_NAME%')
      .join(`<strong>${category}</strong>`)

    return (
      <Subscribe to={[AppContainer]}>
        {appContainer => (
          <ProductWrapper innerRef={wrapper => (this.wrapper = wrapper)}>
            <ProductInner>
              <ProductHeader>
                <ProductTitle>{title}</ProductTitle>
                <ProductImage>
                  <img src={productImageSrc} alt={title} />
                </ProductImage>
              </ProductHeader>
              <ProductContent>
                <ProductIntroTitle
                  dangerouslySetInnerHTML={{ __html: formatted_title }}
                />
                <ProductDescription
                  className="c-body"
                  dangerouslySetInnerHTML={{ __html: html }}
                />
              </ProductContent>
            </ProductInner>
            <div>
              <Button onClick={appContainer.openOrderModal}>
                {order_label} - €60
              </Button>
            </div>
          </ProductWrapper>
        )}
      </Subscribe>
    )
  }
}

export default ProductDetail



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js